module.exports = []


//////////////////
// WEBPACK FOOTER
// ./app/translations/en.json
// module id = ./app/translations/en.json
// module chunks = 10